/*
 * @Author: your name
 * @Date: 2019-12-25 21:54:05
 * @LastEditTime : 2020-01-21 18:32:19
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\vcard.js
 */
const Vcard = () => import('@/views/vcard/index');
const MakeVcard = () => import('@/views/vcard/MakeVcard');
const Card = () => import('@/views/vcard/Card');
const ShareCard = () => import('@/views/vcard/ShareCard');
const vcardRouter = [
    {
        path: '/vcard',
        name: 'vcard',
        component: Vcard,
        meta: {
            name: '电子名片'
        }
    },
    {
        path: '/makeVcard',
        name: 'makeVcard',
        component: MakeVcard,
        meta: {
            name: '电子名片制作'
        }
    },
    {
        path: '/card/:data',
        name: 'card',
        component: Card,
        meta: {
            name: '电子名片'
        }
    },
    {
        path: '/shareCard/:img',
        name: 'shareCard',
        component: ShareCard,
        meta: {
            name: '分享名片'
        }
    },
]
export default vcardRouter;


// WEBPACK FOOTER //
// ./src/router/modules/vcard.js